import React from "react";

interface ScheduledLockBannerProps {
  scheduledDateTime?: Date | string | null;
  dataTestId?: string;
}

const formatScheduled = (value: Date | string): string => {
  const date = typeof value === "string" ? new Date(value) : value;
  if (!date || isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })
    .format(date)
    .replace(/\b(am|pm)\b/i, (m) => m.toUpperCase());
};

const ScheduledLockBanner: React.FC<ScheduledLockBannerProps> = ({
  scheduledDateTime,
  dataTestId = "scheduled-lock-banner",
}) => {
  if (!scheduledDateTime) return null;
  const formatted = formatScheduled(scheduledDateTime);
  if (!formatted) return null;

  return (
    <div className="scheduled-lock-banner" data-testid={dataTestId} role="status">
      <span>
        <strong>Your draw is scheduled to run at {formatted}.</strong> No
        further changes can be made.
      </span>
    </div>
  );
};

export default ScheduledLockBanner;
